import { render, staticRenderFns } from "./ProductCatalogEntityPage.vue?vue&type=template&id=328cdaae&"
import script from "./ProductCatalogEntityPage.vue?vue&type=script&lang=ts&"
export * from "./ProductCatalogEntityPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports